import { cloneDeep, isEmpty } from "lodash";

import { upsertOption } from "~/utilities/reducer";
import { isBrowser } from "~/utilities/helpers";

import { breakpointNumbers } from "~/theme";

export const initHeaderState = {
    bodyIsScrollLocked: false,
    isDesktop: isBrowser
        ? window.innerWidth > breakpointNumbers.desktopMax
        : false,
    mobileMenuIsOpen: false,
    menuOpened: false,
    overlayIsActive: false,
    openedSubnavs: {
        secondary: null,
        tertiary: null,
    },
};

export const headerReducer = (state, action) => {
    let updatedState = state;
    const currentState = cloneDeep(state);

    const { type, id, windowSize, currentSubNavs, level, parent } = action;
    const { openedSubnavs } = currentState;

    switch (type) {
        case "HANDLE_ESCAPE_KEY":
            const tertiaryOpen = openedSubnavs.tertiary;
            updatedState = upsertOption(currentState, {
                menuOpened: tertiaryOpen,
                openedSubnavs: {
                    secondary: tertiaryOpen ? openedSubnavs.secondary : null,
                    tertiary: null,
                },
                mobileMenuIsOpen: false,
            });
            break;
        case "HANDLE_MOBILE_NAVIGATION_CLOSE":
        case "REMOVED_SCROLL_LOCK":
            updatedState = initHeaderState;
            break;
        case "HANDLE_MOBILE_MENU_TOGGLE":
            updatedState = upsertOption(currentState, {
                mobileMenuIsOpen: true,
                overlayIsActive: true,
            });
            break;
        case "HANDLE_SUB_NAV":
            const isOpen = currentSubNavs[level] === id;
            const secondary = level === "secondary";

            let newSubnavs = secondary
                ? {
                      secondary: isOpen ? null : id,
                      tertiary: null,
                  }
                : {
                      ...currentSubNavs,
                      [level]: isOpen ? null : id,
                  };
            updatedState = upsertOption(currentState, {
                menuOpened: !isEmpty(newSubnavs),
                openedSubnavs: newSubnavs,
            });
            break;
        case "HANDLE_RESIZE":
            updatedState = upsertOption(initHeaderState, {
                bodyIsScrollLocked: windowSize > breakpointNumbers.desktopMax,
                isDesktop: windowSize > breakpointNumbers.desktopMax,
            });
            break;
        case "CLOSE_OVERLAY":
            updatedState = upsertOption(initHeaderState, {
                overlayIsActive: false,
            });
            break;
        case "CLOSE_MOBILE_MENU":
        case "HANDLE_CLICK_OUTSIDE":
            updatedState = upsertOption(initHeaderState, {
                bodyIsScrollLocked: true,
                menuOpened: false,
                openedSubnavs: {
                    secondary: null,
                    tertiary: null,
                },
            });
            break;
        case "CLOSE_MOBILE_SUB_NAV":
            updatedState = upsertOption(currentState, {
                menuOpened: level === "tertiary",
                openedSubnavs: {
                    secondary: level === "tertiary" ? parent : null,
                    tertiary: null,
                },
            });
            break;
        default:
            if (isBrowser) {
                console.log(`Unkown Header Action ${action.type}`);
            }
            break;
    }

    return updatedState;
};
